import React, { useState } from 'react';
import { Check } from 'lucide-react';

const PayAsYouGo = ({ onSelectPlan }) => {
  const [selectedPeriod, setSelectedPeriod] = useState('30');
  
const periodOptions = [
  { days: '30', price: 38 },
  { days: '60', price: 76 },
  { days: '90', price: 114 },
  { days: '180', price: 228 },
  { days: '360', price: 456 }
];
  
  const currentPrice = periodOptions.find(option => option.days === selectedPeriod).price;
  
  const handleSelectPlan = () => {
    if (onSelectPlan) {
      onSelectPlan({
        type: 'pay-as-you-go',
        period: selectedPeriod,
        price: currentPrice
      });
    }
  };
  
  const features = [
    'Access to all AI design features',
    'Unlimited project creations',
    'Create interactive designs, prototypes, and flows',
    'Share your designs using secure links',
    'Export HTML and CSS code',
    'No auto-renewals or subscriptions'
  ];

  return (
    <div className="w-full max-w-md mx-auto bg-white rounded-xl shadow-md overflow-hidden border border-gray-200 hover:shadow-lg transition-shadow duration-300">
      <div className="p-6">
        <h3 className="text-xl font-bold text-gray-900 mb-4">Pay as You Go</h3>
        
        {/* Features List */}
        <ul className="mb-6 space-y-3">
          {features.map((feature, index) => (
            <li key={index} className="flex items-start">
              <Check className="h-5 w-5 text-green-500 mr-2 flex-shrink-0 mt-0.5" />
              <span className="text-gray-700">{feature}</span>
            </li>
          ))}
        </ul>
        
        {/* Price Display */}
        <div className="mb-6">
          <div className="flex items-end">
            <span className="text-3xl font-bold text-gray-900">${currentPrice}</span>
            <span className="text-gray-600 ml-2">for {selectedPeriod} days</span>
          </div>
        </div>
        
        {/* Period Selection Dropdown */}
        <div className="mb-6">
          <label htmlFor="period-select" className="block text-sm font-medium text-gray-700 mb-2">
            Select Duration
          </label>
          <select
            id="period-select"
            value={selectedPeriod}
            onChange={(e) => setSelectedPeriod(e.target.value)}
            className="block w-full px-4 py-2 rounded-md border border-gray-300 focus:outline-none focus:ring-2 focus:ring-black focus:border-black"
          >
            {periodOptions.map((option) => (
              <option key={option.days} value={option.days}>
                Pay ${option.price} for {option.days}-day pass
              </option>
            ))}
          </select>
        </div>
        
        {/* Important Notes */}
        <div className="bg-gray-50 rounded-md p-3 mb-6">
          <h4 className="font-semibold text-gray-900 mb-2">Simple & Flexible:</h4>
          <ul className="text-sm text-gray-600 space-y-1 list-inside list-disc">
            <li>No auto-renewals - passes expire automatically without charges</li>
            <li>Complete flexibility - renew only when you need to</li>
            <li>Buy a new pass anytime after expiration, on your schedule</li>
          </ul>
        </div>
        
        {/* CTA Button */}
        <button
          onClick={handleSelectPlan}
          className="w-full bg-black text-white py-3 px-4 rounded-md hover:bg-gray-800 transition-colors duration-200 font-medium"
        >
          Get Started
        </button>
      </div>
    </div>
  );
};

export default PayAsYouGo;